import api from './api';

export function saveUserAccount(user) {
    return api.put(`/admin/update-user/${user.id}`, user);
}

export function unlockUserAccount(userId) {
    return api.put(`/admin/unlock-user/${userId}`);
}

export function getIsAccountLocked(userId) {
    return api.get('/admin/check-user-account-lock/' + userId);
}